var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.UserItems.length > 0 ? _c('div', {
    staticClass: "flex px-0 py-3 justify-end items-center"
  }, [_c('div', [_c('t-dropdown', {
    scopedSlots: _vm._u([{
      key: "trigger",
      fn: function (_ref) {
        var mousedownHandler = _ref.mousedownHandler,
          focusHandler = _ref.focusHandler,
          blurHandler = _ref.blurHandler,
          keydownHandler = _ref.keydownHandler;
        return _c('div', {
          staticClass: "flex z-50"
        }, [_c('button', {
          staticClass: "flex items-center relative justify-center h-10 px-3 py-2.5 text-gray-500 bg-white border border-gray-400 rounded-lg",
          on: {
            "mousedown": mousedownHandler,
            "focus": focusHandler,
            "blur": blurHandler,
            "keydown": keydownHandler
          }
        }, [_c('svg', {
          staticClass: "w-4 h-4 mr-1 text-gray-600 dark:text-white",
          attrs: {
            "aria-hidden": "true",
            "xmlns": "http://www.w3.org/2000/svg",
            "width": "24",
            "height": "24",
            "fill": "currentColor",
            "viewBox": "0 0 24 24"
          }
        }, [_c('path', {
          attrs: {
            "d": "M5.05 3C3.291 3 2.352 5.024 3.51 6.317l5.422 6.059v4.874c0 .472.227.917.613 1.2l3.069 2.25c1.01.742 2.454.036 2.454-1.2v-7.124l5.422-6.059C21.647 5.024 20.708 3 18.95 3H5.05Z"
          }
        })]), _vm._v(" Filter "), _c('svg', {
          staticClass: "w-5 h-5 ml-1 text-gray-600 fill-current",
          attrs: {
            "viewBox": "0 0 20 20",
            "xmlns": "http://www.w3.org/2000/svg"
          }
        }, [_c('polygon', {
          attrs: {
            "points": "9.29289322 12.9497475 10 13.6568542 15.6568542 8 14.2426407 6.58578644 10 10.8284271 5.75735931 6.58578644 4.34314575 8"
          }
        })]), _vm.dataBadge ? _c('div', {
          staticClass: "rounded-full w-5 h-5 bg-red-600 absolute -top-2 -right-2 text-white text-xs flex justify-center items-center"
        }, [_vm._v(" " + _vm._s(_vm.dataBadge) + " ")]) : _vm._e()])]);
      }
    }, {
      key: "default",
      fn: function (_ref2) {
        var hide = _ref2.hide,
          blurHandler = _ref2.blurHandler;
        return _c('div', {
          staticClass: "w-custom bg-white absolute -right-2 pt-2 pb-3 border rounded-lg"
        }, [_c('div', {
          staticClass: "block w-full px-4 py-2 text-sm text-gray-500 transition duration-150 ease-in-out focus:outline-none focus:bg-gray-100",
          attrs: {
            "role": "menuitem"
          }
        }, [_c('div', {
          staticClass: "flex justify-between"
        }, [_c('div', [_vm._v("Filter")]), _c('div', {
          on: {
            "click": hide
          }
        }, [_c('svg', {
          staticClass: "w-4 h-4 text-gray-800 dark:text-white cursor-pointer",
          attrs: {
            "aria-hidden": "true",
            "xmlns": "http://www.w3.org/2000/svg",
            "width": "24",
            "height": "24",
            "fill": "none",
            "viewBox": "0 0 24 24"
          }
        }, [_c('path', {
          attrs: {
            "stroke": "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            "d": "M6 18 17.94 6M18 18 6.06 6"
          }
        })])])]), _c('div', {
          staticClass: "flex justify-between mb-3 mt-2"
        }, [_c('div', {
          staticClass: "w-full mr-2"
        }, [_c('label', {
          staticClass: "text-gray-600 font-semibold mb-3 mt-2"
        }, [_vm._v("Content Type")]), _c('FilterComponent', {
          attrs: {
            "options": _vm.contentTypeOptions,
            "defaultText": 'Select Contents Package Type'
          },
          model: {
            value: _vm.contentType,
            callback: function ($$v) {
              _vm.contentType = $$v;
            },
            expression: "contentType"
          }
        })], 1)]), _c('div', {
          staticClass: "mt-3"
        }, [_c('button', {
          staticClass: "border bg-blue-500 px-4 py-2 text-white rounded-lg",
          on: {
            "click": function ($event) {
              return _vm.filter();
            },
            "blur": blurHandler
          }
        }, [_vm._v(" Filter ")]), _c('button', {
          staticClass: "border bg-white text-gray-500 px-4 py-2 rounded-lg ml-2",
          on: {
            "click": function ($event) {
              return _vm.reset();
            },
            "blur": blurHandler
          }
        }, [_vm._v("Reset")])])])]);
      }
    }], null, false, 2553965077)
  })], 1)]) : _vm._e(), _vm.UserItems.length > 0 ? _c('div', {
    staticClass: "mt-1 border-gray-200 border-b border-t border-r border-l rounded-lg"
  }, [_c('Table', {
    attrs: {
      "headers": _vm.headers,
      "data": _vm.UserItems,
      "row-key": ['id', 'orderline_id', 'item_name', 'item_type', 'item_status', 'user_buffet_id', 'created', 'modified', 'actionbtnSwitch'],
      "current-page": _vm.currentPage,
      "isLoading": _vm.isLoading,
      "withScrollX": true,
      "per-page": _vm.perPage
    },
    scopedSlots: _vm._u([{
      key: "actionbtnSwitch",
      fn: function (_ref3) {
        var row = _ref3.row;
        return [_c('label', {
          staticClass: "switch"
        }, [_c('input', {
          class: {
            isToggleStatus: _vm.tempRowId === row.id ? _vm.tempIsActive : row.is_active
          },
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "checked": _vm.tempRowId === row.id ? _vm.tempIsActive : row.is_active
          },
          on: {
            "change": function ($event) {
              return _vm.onSwitchChange(row);
            }
          }
        }), _c('span', {
          staticClass: "slider"
        })]), _c('t-modal', {
          ref: "modalAction",
          on: {
            "before-close": _vm.onBeforeClose
          }
        }, [_c('div', {
          staticClass: "text-sm flex-col justify-center items-center text-center"
        }, [_c('p', {
          staticClass: "text-lg normal-case font-semibold text-gray-900 mb-2"
        }, [_vm._v(" " + _vm._s(_vm.tempIsActive ? 'Activate' : 'Deactivate') + " contents?")]), _c('div', {
          staticClass: "text-center text-base normal-case"
        }, [_vm._v(" Once you save this data, the status at the selected content will be updated. Please recheck. ")]), _c('div', {
          staticClass: "flex justify-center mb-2 mt-3"
        }, [_c('button', {
          staticClass: "bg-blue-700 rounded-lg px-2.5 py-2 text-white mr-3",
          on: {
            "click": function ($event) {
              return _vm.handleSave();
            }
          }
        }, [_vm._v(" Save ")]), _c('button', {
          staticClass: "border px-2 py-2 rounded-lg",
          on: {
            "click": _vm.handleCancel
          }
        }, [_vm._v(" Cancel ")])])])])];
      }
    }, {
      key: "item_name",
      fn: function (_ref4) {
        var row = _ref4.row;
        return [_vm._v(" " + _vm._s(row.item.name) + " ")];
      }
    }, {
      key: "item_type",
      fn: function (_ref5) {
        var row = _ref5.row;
        return [_vm._v(" " + _vm._s(row.item.item_type) + " ")];
      }
    }, {
      key: "user_buffet_id",
      fn: function (_ref6) {
        var value = _ref6.value;
        return [value ? _c('span', [_vm._v(" Yes ")]) : _c('span', [_vm._v(" No ")])];
      }
    }, {
      key: "item_status",
      fn: function (_ref7) {
        var row = _ref7.row;
        return [row && row.item && row.item.item_status ? _c('span', {
          class: _vm.getStatusClass(row.item.item_status) + ' px-2 py-1 text-sm  rounded-lg'
        }, [_vm._v(" " + _vm._s(row.item.item_status) + " ")]) : _c('span', {
          staticClass: "bg-gray-100 text-gray-600 px-2 py-1 text-sm rounded-lg"
        }, [_vm._v(" - ")])];
      }
    }, {
      key: "header-valid-from-single",
      fn: function (_ref8) {
        var column = _ref8.column;
        return [_c('div', {
          staticClass: "flex items-center gap-1"
        }, [_vm._v(" " + _vm._s(column.label) + " "), _c('button', {
          staticClass: "text-xs text-gray-500",
          on: {
            "click": function ($event) {
              return _vm.sortBy(column.key);
            }
          }
        }, [_c('span', {
          attrs: {
            "href": "#"
          }
        }, [_c('svg', {
          staticClass: "w-3 h-3 ms-1.5",
          attrs: {
            "aria-hidden": "true",
            "xmlns": "http://www.w3.org/2000/svg",
            "fill": "currentColor",
            "viewBox": "0 0 24 24"
          }
        }, [_c('path', {
          attrs: {
            "d": "M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z"
          }
        })])])])])];
      }
    }, {
      key: "header-valid-to-single",
      fn: function (_ref9) {
        var column = _ref9.column;
        return [_c('div', {
          staticClass: "flex items-center gap-1"
        }, [_vm._v(" " + _vm._s(column.label) + " "), _c('button', {
          staticClass: "text-xs text-gray-500",
          on: {
            "click": function ($event) {
              return _vm.sortBy(column.key);
            }
          }
        }, [_c('span', {
          attrs: {
            "href": "#"
          }
        }, [_c('svg', {
          staticClass: "w-3 h-3 ms-1.5",
          attrs: {
            "aria-hidden": "true",
            "xmlns": "http://www.w3.org/2000/svg",
            "fill": "currentColor",
            "viewBox": "0 0 24 24"
          }
        }, [_c('path', {
          attrs: {
            "d": "M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z"
          }
        })])])])])];
      }
    }, {
      key: "created",
      fn: function (_ref10) {
        var row = _ref10.row;
        return [['book', 'magazine'].includes(row.item.item_type) ? _c('div', [_c('span', {
          staticClass: "text-sm"
        }, [_vm._v(" " + _vm._s(_vm.formatDateUTS(row.created).date))]), _c('br'), _c('span', {
          staticClass: "italic text-xs"
        }, [_vm._v(_vm._s(_vm.formatDateUTS(row.created).time))])]) : _c('div', [_c('span', {
          staticClass: "text-sm"
        }, [_vm._v(" " + _vm._s(_vm.formatDate(row.created).date))]), _c('br'), _c('span', {
          staticClass: "italic text-xs"
        }, [_vm._v(_vm._s(_vm.formatDate(row.created).time))])])];
      }
    }, {
      key: "modified",
      fn: function (_ref11) {
        var row = _ref11.row;
        return [['book', 'magazine'].includes(row.item.item_type) ? _c('div', [_c('span', {
          staticClass: "text-sm"
        }, [_vm._v(" " + _vm._s(_vm.formatDateUTS(row.created).date))]), _c('br'), _c('span', {
          staticClass: "italic text-xs"
        }, [_vm._v(_vm._s(_vm.formatDateUTS(row.created).time))])]) : _c('div', [_c('span', {
          staticClass: "text-sm"
        }, [_vm._v(" " + _vm._s(_vm.formatDate(row.created).date))]), _c('br'), _c('span', {
          staticClass: "italic text-xs"
        }, [_vm._v(_vm._s(_vm.formatDate(row.created).time))])])];
      }
    }], null, false, 1123537909)
  })], 1) : _c('div', {
    staticClass: "relative mt-4 overflow-x-auto my-2 mb-4 rounded-lg border-gray-200 border-b border-t border-r border-l"
  }, [!_vm.isLoading ? _c('table', {
    staticClass: "min-w-full h-64 text-sm rounded-lg text-left"
  }, [_vm._m(0), _c('tbody', {
    staticClass: "bg-white w-full"
  }, [_c('tr', [_c('td', {
    staticClass: "text-center py-8 text-gray-500",
    attrs: {
      "colspan": "10"
    }
  }, [_c('div', {
    staticClass: "flex-col items-center justify-center flex-nowrap flex",
    staticStyle: {
      "height": "574px"
    }
  }, [_c('svg', {
    staticClass: "w-14 h-14 text-gray-500 dark:text-white",
    attrs: {
      "aria-hidden": "true",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "fill": "none",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "stroke": "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      "d": "M10 3v4a1 1 0 0 1-1 1H5m4 8h6m-6-4h6m4-8v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1Z"
    }
  })]), _c('h4', {
    staticClass: "text-base text-gray-600 mb-0"
  }, [_vm._v("No Data")]), _c('p', {
    staticClass: "text-sm text-gray-500"
  }, [_vm._v("There are no data to display")])])])])])]) : _vm._e()])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', {
    staticClass: "bg-gray-50 text-gray-700"
  }, [_c('tr', {
    staticClass: "text-center uppercase"
  }, [_c('th', {
    staticClass: "px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b"
  }, [_vm._v("No")]), _c('th', {
    staticClass: "px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b"
  }, [_vm._v("user Contents id")]), _c('th', {
    staticClass: "px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b"
  }, [_vm._v("orderline key")]), _c('th', {
    staticClass: "px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b"
  }, [_vm._v("Contents Name ")]), _c('th', {
    staticClass: "px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b"
  }, [_vm._v("Content Type")]), _c('th', {
    staticClass: "px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b"
  }, [_vm._v("Content Status")]), _c('th', {
    staticClass: "px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b"
  }, [_vm._v("buffets")]), _c('th', {
    staticClass: "px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b"
  }, [_vm._v("Created Date")]), _c('th', {
    staticClass: "px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b"
  }, [_vm._v("modified Date")]), _c('th', {
    staticClass: "px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b"
  }, [_vm._v("Status")])])]);
}]

export { render, staticRenderFns }